import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import VersionsDropdown from './VersionsDropdown';
window.mountVersionsDropdown = function mountVersionsDropdown(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('VersionsDropdown: container not found:', containerId);
        return { unmount: () => { }, get api() { return null; } };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(VersionsDropdown, { ...props, ref: apiRef }));
    return {
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
